<template>
  <div class="content-wrapper  solutions">
    <a href="#"/></a>

    <div class="b-solution-in">
      <breadcrumbs :items="breadcrumbs" />

      <h1 class="b-solution__name">Кухня</h1>
      <div class="b-solution__dots">
        <v-img
          class="b-solution__img"
          src="upload/iblock/bf0/bf0ace5ce79dfffacf2da9920dc30f84.jpg"
          alt=""
          :aspect-ratio="1.629"
        />
        <div data-id="1" class="b-solution__dot" style="top: 92%; left: 8%;">
          1
        </div>

        <div data-id="2" class="b-solution__dot" style="top: 89%; left: 14%;">
          2
        </div>

        <div data-id="3" class="b-solution__dot" style="top: 86%; left: 21%;">
          3
        </div>

        <div data-id="4" class="b-solution__dot" style="top: 83%; left: 28%;">
          4
        </div>

        <div data-id="5" class="b-solution__dot" style="top: 82%; left: 6%;">
          5
        </div>

        <div data-id="6" class="b-solution__dot" style="top: 78%; left: 40%;">
          6
        </div>

        <div data-id="7" class="b-solution__dot" style="top: 49%; left: 50%;">
          7
        </div>

        <div data-id="8" class="b-solution__dot" style="top: 38%; left: 70%;">
          8
        </div>
      </div>

      <div class="b-solution__groups">
        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="1">
            <div class="b-solution__group-key">1</div>
            -
            <div class="b-solution__group-name">Стяжка</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="https://sikahome.ru/upload/iblock/bc5/bc513b5310cf427f0453af997982fd89.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-206 Screed</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Быстротвердеющая стяжка с толщиной нанесения до 60 мм
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="2">
            <div class="b-solution__group-key">2</div>
            -
            <div class="b-solution__group-name">Грунт</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/3f3/3f3c893dfe490f78d2d8a26558428e6f.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-07 Primer Pro</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Концентрат водно-дисперсионного универсального акрилового
                  грунта
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="3">
            <div class="b-solution__group-key">3</div>
            -
            <div class="b-solution__group-name">Наливной пол</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/1a8/1a805a8b9d0b7ca47df2d3d245a0b907.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikafloor®-120 Level Standard</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Самовыравнивающийся наливной пол от 2 до 20 мм с быстрым
                  набором прочности
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="4">
            <div class="b-solution__group-key">4</div>
            -
            <div class="b-solution__group-name">Гидроизоляция</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/1ff/1ff849e1f9660ad70334912b1e2dc7dc.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >Sikalastic®-022 W</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Жидкая полимерная гидроизоляционная мембрана
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="5">
            <div class="b-solution__group-key">5</div>
            -
            <div class="b-solution__group-name">Гидроизоляционная лента</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/c56/c5606fb22c6025d8066f3c753b547a47.jpg"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >Sika® SealTape-S</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Эластичная лента для гидроизоляции углов и примыканий
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="6">
            <div class="b-solution__group-key">6</div>
            -
            <div class="b-solution__group-name">Плиточный клей</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/7c1/7c10cdae94ed6357ae0a01d7b8d91313.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >SikaCeram® Standard
                  </a>
                </div>
                <div class="b-solution__group-item-desc">
                  Плиточный клей для внутренних работ. Класс С0 (ГОСТ Р 56387).
                  Максимальный размер плитки 40х40
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="7">
            <div class="b-solution__group-key">7</div>
            -
            <div class="b-solution__group-name">Герметик</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a href="#">
                  <img
                    src="upload/iblock/ae4/ae4155ba49f4942edfd8f693ae9ffae3.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a href="#"
                    >Sanisil®</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Кислотный санитарный силиконовый герметик
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="b-solution__group">
          <div class="b-solution__group-title" data-id="8">
            <div class="b-solution__group-key">8</div>
            -
            <div class="b-solution__group-name">Монтажный клей</div>
          </div>
          <div class="b-solution__group-desc"></div>

          <div class="b-solution__group-items">
            <div class="b-solution__group-item">
              <div class="b-solution__group-item-img">
                <a
                  href="#"
                >
                  <img
                    src="upload/iblock/c30/c304de710bd7f0a8421c727600ce40f6.png"
                    alt=""
                  />
                </a>
              </div>
              <div class="b-solution__group-item-text">
                <div class="b-solution__group-item-title">
                  <a
                    href="#"
                    >Sikaflex®-118 Extreme Grab</a
                  >
                </div>
                <div class="b-solution__group-item-desc">
                  Клей для фиксации тяжёлых элементов
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p><a href="#"></a></p>
  </div>
</template>

<script>
export default {
    data() {
    return {
      breadcrumbs: [
        {
          label: "Главная",
          to: {name: "main"},
        },
        {
          label: "Решения для дома",
          to: {name: "solutions"},
        },
        {
          label: "Кухня",
        },
      ],
    };
  },
};
</script>

<style lang="scss"></style>
